import { portalApi } from '../../../api';
import { searchItems } from '../../../api/portal-api';
import { CodeActionToStatus } from '../../../constants/codes';
import { modifyArrayItemAt } from '../../../utils/arrayUtil';
import { withSearchBlueprint } from '../../blueprints/search';
import { createErrorToast, createSuccessToast, createToast } from '../app';

const ITEMS_GET_TYPES = 'ITEMS_GET_TYPES';
const ITEMS_GET_TYPES_SUCCESS = 'ITEMS_GET_TYPES_SUCCESS';
const ITEMS_GET_TYPES_FAILURE = 'ITEMS_GET_TYPES_FAILURE';

const ITEMS_RESET = 'ITEMS_RESET';
const ITEM_TYPES_RESET = 'ITEM_TYPES_RESET';

const ITEMS_UPDATE_CODE_STATUS = 'ITEMS_UPDATE_CODE_STATUS';
const ITEMS_UPDATE_CODE_STATUS_SUCCESS = 'ITEMS_UPDATE_CODE_STATUS_SUCCESS';
const ITEMS_UPDATE_CODE_STATUS_FAILURE = 'ITEMS_UPDATE_CODE_STATUS_FAILURE';

const ITEMS_BULK_UPDATE_CODE_STATUS = 'ITEMS_BULK_UPDATE_CODE_STATUS';
const ITEMS_BULK_UPDATE_CODE_STATUS_SUCCESS = 'ITEMS_BULK_UPDATE_CODE_STATUS_SUCCESS';
const ITEMS_BULK_UPDATE_CODE_STATUS_FAILURE = 'ITEMS_BULK_UPDATE_CODE_STATUS_FAILURE';

/* Actions
================================================== */
export const getItemTypes = (companyId, pageNumber = 1) => async dispatch => {
  dispatch({ type: ITEMS_GET_TYPES });

  const pageData = { pageNumber, pageSize: 10 };
  const includes = { include: 'item_type_properties' };

  try {
    const { data, ...pageInfo } = await portalApi.getItemTypes(companyId, includes, pageData);
    dispatch({ type: ITEMS_GET_TYPES_SUCCESS, data, pageInfo });
  } catch (error) {
    dispatch({ type: ITEMS_GET_TYPES_FAILURE, error });
  }
};

export const itemTypesReset = () => dispatch => {
  dispatch({ type: ITEM_TYPES_RESET });
};

export const itemsReset = () => dispatch => {
  dispatch({ type: ITEMS_RESET });
};

export const updateItemCodeStatus = (itemId, codeId, codeAction, letter, comment) => async (dispatch, getState) => {
  dispatch({ type: ITEMS_UPDATE_CODE_STATUS, itemId, codeId, codeAction });

  dispatch(itemSearch.updateItem('id', itemId, item => {
    const codeIndex = item.codes.findIndex(itemCodes => itemCodes.letter === letter);
    const status = CodeActionToStatus[codeAction];

    if (codeIndex >= 0) {
      item.codes = modifyArrayItemAt(item.codes, 'letter', letter, code => ({
        ...code,
        status
      }));
    } else {
      item.codes = [...item.codes, {
        status,
        id: codeId,
        letter
      }];
    }

    return item;
  }));

  try {
    const itemCode = await portalApi.updateItemCodeStatus(itemId, codeId, codeAction, comment);
    dispatch({ type: ITEMS_UPDATE_CODE_STATUS_SUCCESS, itemCode, itemId, codeId, codeAction, comment });
  } catch (error) {
    dispatch({ type: ITEMS_UPDATE_CODE_STATUS_FAILURE, itemId, codeId, codeAction, error });
  }
};

export const bulkUpdateItemCodeStatuses = (
  insuredId,
  codes,
  status,
  itemSearchParams,
  comment = null,
  onSuccess = () => {},
  onFail = () => {}
) => async dispatch => {
  dispatch({ type: ITEMS_BULK_UPDATE_CODE_STATUS, insuredId, codes, status, itemSearchParams, comment });

  dispatch(createToast({ title: 'Bulk Update Processing...' }));

  try {
    const promises = codes.map(code => portalApi.bulkUpdateItemCodeStatuses(insuredId, code.id, status, itemSearchParams, comment));
    const response = await Promise.all(promises);
    dispatch({ type: ITEMS_BULK_UPDATE_CODE_STATUS_SUCCESS, response });
    dispatch(createSuccessToast({ title: 'Bulk Update Initiated!', description: 'This may take a few minutes.  Refresh the page to see the changes.' }));
    onSuccess();
  } catch (error) {
    dispatch({ type: ITEMS_BULK_UPDATE_CODE_STATUS_FAILURE, error });
    dispatch(createErrorToast({ title: 'Something went wrong with your bulk update.', error }));
    onFail();
  }
};

const DEFAULT_STATE = {
  itemTypes: [],
  itemTypesPageInfo: {}
};

const itemsReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case ITEMS_GET_TYPES_SUCCESS:
      return {
        ...state,
        itemTypes: action.data,
        itemTypesPageInfo: action.pageInfo
      };

    case ITEM_TYPES_RESET:
      return {
        ...state,
        data: [],
        itemTypes: [],
        itemTypesPageInfo: {}
      };

    case ITEMS_RESET:
      return {
        ...state,
        data: DEFAULT_STATE.data
      };

    default:
      return state;
  }
};

export const selectItemTypes = state => state.items.base.itemTypes;
export const selectItemTypesPageInfo = state => state.items.base.pageInfo;

export const { reducer, ...itemSearch } = withSearchBlueprint('items', itemsReducer, { endpoint: searchItems });
